<template>
    <button v-if="secondary" :disabled="disabled" :class="[!ignoreDarkMode ? 'dark:ring-racing-stars-yellow dark:text-racing-stars-yellow hover:bg-opacity-80' : '', button]" :type="type" class="disabled:opacity-50 disabled:cursor-not-allowed disabled:text-white font-semibold inline-flex justify-center items-center border border-transparent font-medium text-gray-700 hover:text-white focus:outline-none ring-2 focus:ring-offset-2 ring-gray-700 transition duration-500 ease-in-out">
        <slot></slot>
    </button>
    <button v-else :type="type" :class="button" :disabled="disabled" class="disabled:bg-gray-800 disabled:opacity-50 disabled:cursor-not-allowed inline-flex font-semibold justify-center items-center border border-transparent font-medium shadow-sm text-white bg-gray-800 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-700 transition duration-500 ease-in-out dark:bg-racing-stars-yellow dark:text-gray-800 dark:hover:bg-opacity-80">
        <slot></slot>
    </button>
</template>
<script>
export default {
    props: {
        ignoreDarkMode: Boolean,
        secondary: Boolean,
        disabled: Boolean,
        xs: Boolean,
        sm: Boolean,
        lg: Boolean,
        xl: Boolean,
        type: {
            default: 'button'
        }
    },
    computed: {
        button() {
            return {
                'px-2.5 py-1.5 text-xs sm:rounded': this.xs,
                'px-3 py-2 text-sm leading-4 sm:rounded-md': this.sm,
                'px-4 py-2 text-sm sm:rounded-md': !this.xs && !this.sm && !this.lg && !this.xl,
                'px-4 py-2 text-base sm:rounded-md': this.lg,
                'px-6 py-3 text-base sm:rounded-md': this.xl,
            }
        }
    }
}

</script>
